// Styles for CreateAccountForm go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { constants } from '../../../modules';

export const StyledCreateAccountForm = styled.div`
  .activate_account--countrydropdown {
    width: 100% !important;
    display: flex;
    align-items: center;
    &__standard {
      border-radius: ${toRem(4)} !important; //important is given to override the dropdown css property
      border-color: ${baseVariables.color['neutral40']} !important;
      padding-top: ${toRem(12)} !important;
      padding-bottom: ${toRem(12)} !important;
      height: ${toRem(44.67)};
      .icon-dropdown-down,
      .icon-dropdown-up {
        position: absolute;
        right: ${toRem(8)};
      }
      &:is(${constants.NOTO_SANS_LANG_LIST}) {
        height: ${toRem(48.66)};
      }
      &:is(${constants.ARABIC_LANG}) {
        height: ${toRem(55.33)};
      }
      &:is(${constants.HEBREW_LANG}) {
        height: ${toRem(41.33)};
      }
    }
  }

  .dropdown {
    cursor: pointer;
  }
  .dropdown-value {
    font-size: ${toRem(16)};
  }

  .dropdown__container {
    color: ${baseVariables.color['neutral40']} !important;
    z-index: 2;
  }
  .country-label {
    z-index: 1;
  }
  .m-dropdown-container {
    .m-dropdown-children {
      height: auto;
      max-height: ${toRem(224)};
    }
  }

  .dropdown__container {
    z-index: 99;
  }
  .password-checks {
    margin-bottom: ${toRem(24)} !important;
  }
  .pointer-cursor {
    cursor: pointer;
    text-decoration: underline;
  }
  .disableField * {
    color: ${baseVariables.color['neutral30']} !important;
    border-color: ${baseVariables.color['neutral30']} !important;
  }
  .m-input-field {
    &.is-disabled {
      label {
        z-index: 1;
      }
    }
    caret-color: inherit; // This is to override transparent caret color
  }
  .error-label,
  .error-label * {
    font-size: ${baseVariables.font.fontXs};
    color: ${baseVariables.color.alert50} !important;
  }

  .create-account__link {
    @media ${baseVariables.mediaQuery.md} {
      align-items: center;
    }
  }

  .link-underline {
    font-size: ${toRem(16)};
    display: inline-block;
    width: fit-content;
    &:is(${constants.NOTO_SANS_LANG_LIST}) {
      line-height: ${toRem(18)};
    }
  }
  .m-badge-inline-neutral {
    padding: 0;
    background-color: ${baseVariables.color.merch50} !important;
    color: ${baseVariables.color.neutral40} !important;
    text-align: unset !important;
  }

  .dropdown-field {
    label {
      left: ${toRem(16)}; // to override left spacing when ellipsis gets added
      @media ${baseVariables.mediaQuery.lg} {
        left: ${toRem(20)}; // to override left spacing when ellipsis gets added
      }
    }
  }

  .account-page-error-msg p {
    margin-bottom: 0 !important;
  }
  .create-password-eaa {
    .password-checks {
      margin-bottom: ${toRem(16)} !important;
    }
  }

  .resend-code {
    p {
      margin-bottom: 0 !important;
    }
  }
  .is-disabled {
    .password-checks {
      &__description {
        color: ${baseVariables.color.neutral30} !important;
      }
    }
  }
  .create-account-password {
    .password-checks {
      &__errorlabel {
        font-weight: 400 !important;
      }
    }
  }
  .country-code-dropdown {
    display: flex;
    align-items: center;
  }
  .m-input-text-field
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightL};
    padding: ${toRem(26)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']):focus {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio'])
    + span {
    color: ${baseVariables.color.alert50};
    font-size: ${baseVariables.font.fontXs};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${baseVariables.font.lineHeightS};
  }
  .sign-in-ko {
    a {
      border-bottom: none;
    }
  }
  .m-input-text-field-v3 label {
    padding-left: inherit;
  }
  .link-reservation-section {
    background-color: ${baseVariables.color.neutral10};
    margin: ${toRem(48)} ${toRem(-16)} !important;
    padding: 2rem ${toRem(16)} !important;

    @media ${baseVariables.mediaQuery.md} {
      margin: ${toRem(48)} ${toRem(-48)} !important;
      padding: 2rem ${toRem(48)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      margin: ${toRem(48)} ${toRem(-80)} !important;
      padding: 2rem ${toRem(80)} !important;
    }

    .help-text {
      &-decoration {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    input[type='number'] {
      background-color: ${baseVariables.color.base20} !important;
    }
    .disabled {
      color: ${baseVariables.color.neutral40} !important;
    }
    button {
      width: 100%;
      @media ${baseVariables.mediaQuery['sm']} {
        width: auto;
      }
    }
  }
`;
